<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  input[aria-hidden=true]{
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue